/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useChangePassword = () =>
  useMutation({
    mutationFn: (data: any) =>
      client("auth/change/password/v2", {
        data,
        successMessage: "Password updated successfully!",
      }),
  });
